<div class="form-group">
    <div class="search-input-with-btn">
        <label [for]="id" class="accesibleHidden">Buscador</label>
        
        <input 
        type="search" 
        class="form-control" 
        [id]="id"
        [name]="id"
        [title]="title" 
        [maxlength]="maxlength"
        [placeholder]="placeholder"
        (keyup.enter)="onClickButtonSearch($event)"
        [formControl]="control" />

        <button type="submit" class="btn btn-search" title="Buscar" (click)="onClickButtonSearch($event)">
            <i class="pj-ico pj-ico-buscar"></i>
        </button>

    </div>
</div>